import { FormatState } from 'common/stores/FormatStateStore';
import { HeavyAdHandler } from './HeavyAdHandler';
import { FrameLifecycleHandler } from './frame-lifecycle-handler';

export function getMwebSupplyEventsHandlers(
  formatContext: AdContext,
  formatState: FormatState
) {
  return [
    new HeavyAdHandler(formatContext, formatState),
    new FrameLifecycleHandler()
  ];
}
